/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { OperationPart as IOperationPart } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import { RootState } from 'app/AppStore';
import { getLastVehicle } from 'domains/catalog/Catalog.store';
import { getPricesMap, getStocksMapV2 } from 'domains/references';
import { getDealerType, getTokenUser } from 'domains/user';
import EasyBasketReferenceCard from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/EasyBasketReferenceCard';
import { getPartPosition, PartPosition } from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/utils';
import {
  getFilteredAndSortedReferences,
  mapOperationParts,
} from 'pages/CatalogPage/DH/SubcategorySection/SparePartsSection/ReferenceCardsContainer/utils';

const OperationPart = ({
  operationPart,
  multipleReferencesGroup,
  mainReferencePosition,
  itemGroup,
  isOnlyOriginalPartReference,
}: {
  itemGroup: string;
  multipleReferencesGroup: boolean;
  mainReferencePosition: PartPosition;
  operationPart: IOperationPart;
  isOnlyOriginalPartReference: boolean;
}) => {
  const vehicle = useSelector(getLastVehicle);
  const tokenUserCountry = useSelector(getTokenUser)?.country;
  const dealerType = useSelector(getDealerType);
  const alternativesRefNumbers = operationPart?.alternativeParts?.map((ref) => ref.reference) ?? [];
  const prices = useSelector((state: RootState) => getPricesMap(state, alternativesRefNumbers));
  const stocks = useSelector((state: RootState) => getStocksMapV2(state, alternativesRefNumbers));
  const referencesToDisplay = getFilteredAndSortedReferences({
    references: mapOperationParts(operationPart.alternativeParts ?? []),
    dealerType,
    vehicle: vehicle?.vehicleDetail,
    prices,
    stocks,
    country: tokenUserCountry,
  });

  return (
    <>
      <EasyBasketReferenceCard
        key={operationPart.reference}
        mainReferenceNumber={operationPart.reference}
        referenceNumber={operationPart.reference}
        designation={operationPart?.designation ?? ''}
        brand={operationPart.brand ?? 'OTHER'}
        itemGroup={itemGroup}
        quantity={operationPart.quantity}
        mainReferencePosition={mainReferencePosition}
        isMultipleReferencesGroup={multipleReferencesGroup}
        hasSuperSessionChain={operationPart?.superSessionDetails && operationPart.superSessionDetails.length > 0}
        isOnlyOriginalPartReference={isOnlyOriginalPartReference}
      />
      {referencesToDisplay.map((altRef, index) => (
        <EasyBasketReferenceCard
          key={altRef.referenceNumber}
          mainReferenceNumber={operationPart.reference}
          referenceNumber={altRef.referenceNumber}
          designation={altRef.designation ?? ''}
          brand={altRef.brand ?? 'OTHER'}
          itemGroup={itemGroup}
          quantity={operationPart.quantity}
          mainReferencePosition={mainReferencePosition}
          isMultipleReferencesGroup={multipleReferencesGroup}
          alternativeReferencePosition={getPartPosition(index, alternativesRefNumbers.length)}
          isAlternative
          hasSuperSessionChain={operationPart?.superSessionDetails && operationPart.superSessionDetails.length > 0}
          isOnlyOriginalPartReference={isOnlyOriginalPartReference}
        />
      ))}
    </>
  );
};

export default OperationPart;
